<template>
  <div>
    <!-- Barra superior -->
    <v-app-bar app clipped-left fixed dense>
      <v-btn
        icon
        aria-label="Abrir menú"
        @click.stop="drawer = !drawer"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <v-toolbar-title
        class="subtitle-2 ml-2 font-weight-bold text-truncate"
      >
        {{ $route.meta.title || 'Transten' }}
      </v-toolbar-title>

      <v-spacer />

      <span class="text-caption d-none d-sm-inline mr-3">
        {{ userName }}
      </span>
    </v-app-bar>

    <!-- Menú lateral -->
    <v-navigation-drawer
      v-model="drawer"
      temporary
      fixed
      width="286"
      class="menu-drawer"
    >
      <!-- Encabezado fijo -->
      <template v-slot:prepend>
        <v-list-item class="px-4">
          <v-list-item-title class="font-weight-bold">
            Transten
          </v-list-item-title>

          <v-spacer />

          <v-btn
            icon
            aria-label="Cerrar menú"
            @click="drawer = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item>

        <v-divider />
      </template>

      <!-- Menú central con scroll -->
      <div class="menu-content">
        <v-list dense nav rounded>
          <template v-for="item in items">
            <v-list-group
              v-if="isModuleVisible(item)"
              :key="item.heading"
              :value="false"
              :prepend-icon="item.icon"
              no-action
              color="accent"
              class="pt1 mt1 pb1 mb1"
            >
              <!-- Nombre del módulo -->
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.heading }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <!-- Opciones del módulo -->
              <template 
                v-for="(child, childIndex) in visibleChildren(item)"
              >
                <!-- Subtítulo dentro del módulo -->
                <v-subheader
                  v-if="child.subheader"
                  :key="item.heading + '-subheader-' + childIndex"
                >
                  {{ child.text }}
                </v-subheader>

                <!-- Opción del menú -->
                <v-list-item
                  v-else
                  :key="item.heading + '-' + child.text"
                  :to="child.link || undefined"
                  :disabled="child.disabled || false"
                  link
                >
                  <v-list-item-icon v-if="child.icon">
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ child.text }}
                    </v-list-item-title>

                    <v-list-item-subtitle v-if="child.subtitle">
                      {{ child.subtitle }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </v-list>
      </div>

      <!-- Sección inferior fija -->
      <template v-slot:append>
        <v-divider />

        <v-subheader>Configuración</v-subheader>

        <v-list dense nav>
          <!-- Modo oscuro -->
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-brightness-6</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                Modo oscuro
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-switch
                v-model="darkMode"
                dense
                hide-details
                color="accent"
              />
            </v-list-item-action>
          </v-list-item>

          <!-- Inicio -->
          <v-list-item
            :to="{ name: 'home' }"
            @click="drawer = false"
          >
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                Inicio
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Cerrar sesión -->
          <v-list-item
            :to="{ name: 'logout' }"
            @click="drawer = false"
          >
            <v-list-item-icon>
              <v-icon color="error">
                mdi-logout
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                Cerrar sesión
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { can } from '../../src/helpers/permissions';

export default {
  data: () => ({
    drawer: false,
    items: [
      {
        heading: 'Logística',
        permission: ['get-routes'],
        children: [
          {
            text: 'Catálogo de rutas',
            icon: 'mdi-routes',
            link: { name: 'routes' },
            permission: 'get-routes',
          },
          
        ],
      },
      {
        heading: 'Catálogos',
        permission: ['get-users'],
        children: [
          {
            text: 'Usuarios y roles',
            icon: 'mdi-account-group',
            link: { name: 'users' },
            permission: 'get-users',
          },
        ],
      },
      {
        heading: 'Otros módulos',
        permission: [],
        children: [
          {
            text: 'Dashboard',
            subtitle: 'En adaptación',
            icon: 'mdi-view-dashboard',
            disabled: true,
          },
          {
            text: 'Reporte detallado',
            icon: 'mdi-chart-box-outline',
            permission: 'get-report-binnacle',
            subtitle: 'En adaptación',
            disabled: true,
          },
          {
            text: 'Unidades',
            icon: 'mdi-truck-outline',
            permission: 'get-unities',
            subtitle: 'En adaptación',
            disabled: true,
          },
        ],
      },
    ],
  }),
  computed: {
    ...mapState('configuration', ['themeDark']),
    ...mapGetters('configuration', ['getAbilitiesUser', 'getConfigurationName']),
    userName() { return this.getConfigurationName; },
    darkMode: {
      get() { return this.themeDark; },
      set(value) { this.setDarkMode(value); this.$vuetify.theme.dark = value; },
    },
  },
  methods: {
    ...mapActions('configuration', ['setDarkMode']),
    can(permission) { 
      return can(this.getAbilitiesUser, permission); 
    },

    hasPermission(permission) {
      // Si no se define un permiso, la opción es pública.
      if (
        !permission ||
        (Array.isArray(permission) && permission.length === 0)
      ) {
        return true;
      }

      return this.can(permission);
    },

    isModuleVisible(item) {
      // El módulo debe tener permiso y al menos una opción visible.
      return (
        this.hasPermission(item.permission) &&
        this.visibleChildren(item).some(child => !child.subheader)
      );
    },

    visibleChildren(item) {
      const visible = item.children.filter(child =>
        child.subheader || this.hasPermission(child.permission)
      );

      // Evita mostrar subtítulos sin opciones disponibles.
      return visible.filter((child, index) => {
        if (!child.subheader) return true;

        const nextHeader = visible.findIndex(
          (next, i) => i > index && next.subheader
        );

        const end = nextHeader === -1 ? visible.length : nextHeader;

        return visible.slice(index + 1, end).some(
          next => !next.subheader
        );
      });
    },


  },
  mounted() { 
    this.$vuetify.theme.dark = this.themeDark; 
  },
};
</script>

<style scoped>

  .menu-drawer {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  /*
  * El contenido interno del drawer ocupa la altura disponible.
  * El encabezado y el menú central se organizan en columna.
  */
  .menu-drawer >>> .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  /* Encabezado: conserva su altura */
  .menu-drawer >>> .v-navigation-drawer__content > .v-list-item,
  .menu-drawer >>> .v-navigation-drawer__content > .v-divider {
    flex-shrink: 0;
  }

  /* Acercar las opciones hijas hacia la izquierda */
  .menu-drawer >>> .v-list-group__items .v-list-item {
    padding-left: 32px !important;
  }

  /* Alinear los iconos y textos de las opciones hijas */
  .menu-drawer >>> .v-list-group__items .v-list-item__icon {
    margin-right: 20px;
  }
  /* Separación entre los encabezados de los módulos */
  .menu-drawer >>> .v-list-group {
    margin-bottom: 4px;
  }

  /* Un pequeño espacio antes de las opciones desplegadas */
  .menu-drawer >>> .v-list-group__items {
    padding-bottom: 4px;
  }

  /* Solo esta zona se desplaza */
  .menu-content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  /* Scroll discreto */
  .menu-content {
    scrollbar-width: thin;
  }
</style>